import React from 'react'
import PropTypes from 'prop-types'
import antNotification from 'antd/es/notification'
import { notification } from '@edulastic/common'
import { themeColorLight } from '@edulastic/colors'
import { segmentApi } from '@edulastic/api'
import { Button } from 'antd'
import { TEST_LIBRARY_TABS } from '../../../../../TestList/utils/pdlBulkUploadHandoff'

export const CREATED_BY_ME_TESTS_PATH = `/author/tests?filter=AUTHORED_BY_ME&tab=${TEST_LIBRARY_TABS.MY_CONTENT}&page=1&limit=20`

/** Toast message body for successful Review Done / Approve and move. */
export const MarkTestAsReviewedSuccessMessage = ({
  href,
  onGoToCreatedByMe,
  moveTest = true,
}) => (
  <>
    {moveTest ? 'Test approved and moved successfully' : 'Test approved successfully'}
    {moveTest && (
      <Button
        style={{
          color: themeColorLight,
          border: 'none',
        }}
        type="link"
        href={href}
        data-cy="goToCreatedByMe"
        onClick={(e) => {
          e.preventDefault()
          onGoToCreatedByMe()
        }}
      >
        GO TO CREATED BY ME
      </Button>
    )}
  </>
)

MarkTestAsReviewedSuccessMessage.propTypes = {
  href: PropTypes.string.isRequired,
  onGoToCreatedByMe: PropTypes.func.isRequired,
  moveTest: PropTypes.bool,
}

MarkTestAsReviewedSuccessMessage.defaultProps = {
  moveTest: true,
}

/**
 * Shows the success toast.
 * @param {object} options
 * @param {string} [options.testId]
 * @param {() => void} options.onGoToCreatedByMe - SPA navigate (e.g. history.push)
 * @param {boolean} [options.moveTest] - show move-to-Created By Me messaging
 */
export function showMarkTestAsReviewedSuccessToast({
  testId,
  onGoToCreatedByMe,
  moveTest = true,
} = {}) {
  const toastKey = `mark-test-reviewed-${testId || Date.now()}`
  const href =
    typeof window !== 'undefined'
      ? `${window.location.origin}${CREATED_BY_ME_TESTS_PATH}`
      : CREATED_BY_ME_TESTS_PATH
  const handleGoToCreatedByMe = () => {
    antNotification.close(toastKey)
    if (typeof onGoToCreatedByMe === 'function') {
      onGoToCreatedByMe()
      segmentApi.genericEventTrack('test_library_link_clicked', {
        testId,
      })
    }
  }
  notification({
    type: 'success',
    key: toastKey,
    style: moveTest ? { width: 590 } : undefined,
    msg: (
      <MarkTestAsReviewedSuccessMessage
        href={href}
        onGoToCreatedByMe={handleGoToCreatedByMe}
        moveTest={moveTest}
      />
    ),
  })
}
